// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"131":"d71fa1a7","796":"04bee9d3"}[chunkId] + ".bundle.js";
};